import TextField from "@material-ui/core/esm/TextField";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './FormStyles';
export default function SearchBar({
  id,
  placeholder,
  onChange
}) {
  const {
    t
  } = useTranslation();
  const {
    formStylesRoot
  } = useStyles();
  const placeholderText = t('agreements.agreement_details.search');
  return /*#__PURE__*/React.createElement(TextField, {
    className: formStylesRoot,
    placeholder: placeholder || placeholderText,
    type: "search",
    variant: "outlined",
    onChange: e => onChange(e.target.value),
    inputProps: {
      id
    }
  });
}
SearchBar.defaultProps = {
  placeholder: null,
  id: null
};